//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ViuLabel from 'viu/components/viu-label/viu-label.vue';
import ViuSelect from 'viu/components/viu-select/viu-select.vue';
import ViuInput from 'viu/components/viu-input/viu-input.vue';
import NifValidatorMixin from '$mixins/nif-validator-mixin.js';
import validateForm from '$lib/validate-form.js';

export default {
  name: 'Contacto',
  components: {
    ViuLabel,
    ViuSelect,
    ViuInput
  },
  mixins: [NifValidatorMixin],
  props: {
    staticData: Object,
    contacto: Object,
    index: Number
  },
  data() {
    return {
      nifChecked: false
    };
  },
  computed: {
    computedErrorPattern() {
      if (
        this.contacto.documentType === 4 &&
        this.contacto.document.length > 7 &&
        this.contacto.document.length < 10
      ) {
        return 'NIF incorrecto';
      }
      return 'Formato incorrecto';
    },
    computedPattern() {
      let regexp = /[\s\S]*/;
      if (
        this.contacto.documentType === 7 ||
        this.contacto.documentType === 6 ||
        this.contacto.documentType === ''
      ) {
        return regexp;
      }
      if (this.contacto.documentType === 4 && this.contacto.personType === 2) {
        regexp = /^[a-zA-Z]{1}\d{7}[a-zA-Z0-9]{1}$/;
        return regexp;
      }
      if (this.contacto.documentType === 4 && this.contacto.personType === 1) {
        regexp = /^\d{8}[a-zA-Z]{1}$/;
        return regexp;
      }
      if (this.contacto.documentType === 8 && this.contacto.personType === 1) {
        regexp = /^[XxTtYyZz]{1}([0-9]{7}|[0-9]{8})[a-zA-Z]{1}$/;
        return regexp;
      }
      if (this.contacto.documentType === 5) {
        regexp = /^[a-zA-Z]{2}[a-zA-Z0-9]{1,12}$/;
        return regexp;
      }
      return regexp;
    }
  },
  watch: {
    'contacto.document': {
      handler(valor) {
        if (/[a-z]/.test(valor)) {
          this.contacto.document = this.contacto.document.toUpperCase();
        }
        if (this.contacto.documentType === 4 && this.contacto.document === '') {
          this.contacto.personType = 1;
        }
        if (
          this.contacto.documentType === 8 ||
          (this.contacto.documentType === 4 && /[0-9]/.test(this.contacto.document[0])) ||
          this.contacto.documentType === 7
        ) {
          this.contacto.personType = 1;
        }

        if (
          /[a-zA-Z]/.test(this.contacto.document[0]) &&
          this.contacto.documentType === 4 &&
          this.contacto.document !== ''
        ) {
          this.contacto.personType = 2;
        }

        if (this.contacto.documentType === 5 || this.contacto.documentType === 6) {
          this.contacto.personType = 2;
        }

        this.checkNIFIdentifier();
      }
    },
    'contacto.documentType': {
      handler() {
        if (this.contacto.documentType === 4 && this.contacto.document === '') {
          this.contacto.personType = 1;
        }
        if (
          this.contacto.documentType === 8 ||
          (this.contacto.documentType === 4 && /[0-9]/.test(this.contacto.document[0])) ||
          this.contacto.documentType === 7
        ) {
          this.contacto.personType = 1;
        }
        if (
          this.contacto.documentType === 4 &&
          /[a-zA-Z]/.test(this.contacto.document[0]) &&
          this.contacto.document !== ''
        ) {
          this.contacto.personType = 2;
        }
        if (this.contacto.documentType === 5 || this.contacto.documentType === 6) {
          this.contacto.personType = 2;
        }

        this.checkNIFIdentifier();
      }
    }
  },
  methods: {
    checkNIFIdentifier() {
      this.nifChecked = false;

      if (
        this.contacto.documentType === 4 &&
        (this.contacto.document.length === 8 || this.contacto.document.length === 9) &&
        (/^[a-zA-Z]{1}\d{7}[a-zA-Z0-9]{1}$/.test(this.contacto.document) ||
          /^\d{8}[a-zA-Z]{1}$/.test(this.contacto.document))
      ) {
        const validNIF = this.NIFValidator(this.contacto.document);

        if (!validNIF) {
          this.nifChecked = true;
        }
      }
    },
    validate() {
      return validateForm.validate(this, []);
    }
  }
};
